import { Alert, List, Text, View } from "@instructure/ui";
import { useTranslation } from "react-i18next";

const UnapprovedOutcomesList = ({ currentSection }) => {
  const { t } = useTranslation();

  return (
    <View position="relative" tabIndex="0" role="button">
      <div
        style={{
          border: "1px solid #89CFF0",
          padding: 10,
          borderRadius: "5px",
        }}
      >
        <Text>{t("dashboard.unapprovedDisclaimer")}</Text>
      </div>
      <List isUnstyled>
        {currentSection?.unapproved_outcomes?.length > 0 ? (
          currentSection.unapproved_outcomes.map((outcome, key) => (
            <List.Item key={key} margin="small 0">
              <div
                style={{
                  color: "#0D323F",
                  backgroundColor: "#FFD580",
                  border: "1px solid #333",
                  borderRadius: "10px",
                  padding: "5px 15px",
                  marginBottom: 10,
                }}
              >
                <Text size="small">
                  {outcome.name && (
                    <Text size="small" weight="bold">
                      {outcome.name}:{" "}
                    </Text>
                  )}
                  {outcome.statement}
                </Text>
              </div>
            </List.Item>
          ))
        ) : (
          <List.Item>
            <Alert>{t("dashboard.noUnapprovedOutcomes")}</Alert>
          </List.Item>
        )}
      </List>
    </View>
  );
};

export default UnapprovedOutcomesList;
